<template>
  <div v-if="errorMessage || $slots.errorMessage" class="text-sm text-red">
    <template v-if="$slots.errorMessage">
      <slot name="error-message"/>
    </template>

    <p v-else>
      {{ errorMessage }}
    </p>
  </div>
</template>

<scrip setup>
defineProps({
errorMessage: String,
})
</scrip>
